import { createRouter, createWebHistory } from 'vue-router';
import { createMetaManager, defaultConfig, plugin as vueMetaPlugin } from 'vue-meta';
import routes from './routes.js';
import { setActiveSection } from './middleware.js';

// Create a Vue Router instance
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,

  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    return { left: 0, top: 0, behavior: "smooth" };
  }
});
// =======================
// TRACKING NUR AUF /itberatung UND /kontaktform
// Wenn der Nutzer von einer Tracking-Seite (meta.tracking: true)
// auf eine normale Seite wechselt, wird die Seite komplett neu geladen.
// Dadurch sind Google Analytics, Google Ads und LinkedIn auf der
// neuen Seite nicht mehr aktiv.
// =======================
router.beforeEach((to, from) => {
   if (from.meta?.tracking && !to.meta?.tracking && (window.dataLayer || window.lintrk)) {
    window.location.href = to.fullPath;
    return false;
  }
});

// Apply middleware
router.beforeEach(setActiveSection);

// Create a Meta Manager instance for managing meta information
const metaManager = createMetaManager(false, {
  meta: defaultConfig,
});

// Export router and metaManager
export { router, metaManager };

// Install Vue Router and Meta Manager into the Vue app
export default {
  install: (app) => {
    app.use(router);
    app.use(metaManager);
    app.use(vueMetaPlugin);
  },
};
